/*###########################################################################
// Footer
//#########################################################################*/

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

const footer = {
	config: {
		footer: '.footer',
	},

	scrollTrigger: null,

	elements: {},

	init() {
		const self = this

		self.elements.footer = document.querySelector(self.config.footer)

		if (self.elements.footer !== null) {
			self.handleFooter()
		}
	},

	handleFooter() {
		const self = this

		self.scrollTrigger = new ScrollTrigger({
			trigger: self.elements.footer,
			start: 'center bottom',
			onEnter: () => {
				self.elements.footer.classList.add('footer--visible')
				if (self.scrollTrigger !== null) {
					self.scrollTrigger.kill()
				}
			},
		})
	}
}

if (document.readyState === 'complete') {
	footer.init()
} else {
	window.addEventListener('load', () => {
		footer.init()
	})
}
